import Button from '@atoms/Button/Button';
import Search from '@atoms/Search/Search';
import { IFilterGroup } from '@models/IFilterGroup';
import { QueryState } from '@models/IListingWrapper';
import {
  useListingDispatch,
  useListingState,
} from '@utility/context/ListingContext';
import { ActionType } from '@utility/reducers/ListingWrapper';
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';

interface Props {
  readonly autoCompleteEndpoint: string;
  readonly autoCompletePlaceholder: string;
  readonly disabled: boolean;
  readonly errors: FieldErrors<QueryState>;
  readonly filters: IFilterGroup[];
  readonly initialSearchText: string;
  readonly openLabel: string;
  readonly showSearchInListing?: boolean;
  readonly handleFormSubmit: () => void;
  readonly onAutoCompleteSubmit: (value: string) => void;
  readonly register: UseFormRegister<QueryState>;
  readonly setValue: UseFormSetValue<QueryState>;
}

const ListingMobileFilters = ({
  autoCompleteEndpoint,
  autoCompletePlaceholder,
  disabled,
  errors,
  filters,
  handleFormSubmit,
  initialSearchText,
  onAutoCompleteSubmit,
  openLabel,
  register,
  setValue,
  showSearchInListing,
}: Props) => {
  const { isMobileFiltersOpen, clearSearch } = useListingState();
  const dispatch = useListingDispatch();

  return (
    <div className="tw-sticky tw-top-[56px] tw-z-30 tw-gap-sm tw-bg-grey-10 tw-py-xs lg:tw-hidden">
      {/* Mobile Filters */}
      {!!filters.length && (
        <div className="tw-container tw-block lg:tw-inline-block">
          <Button
            aria-label={openLabel}
            aria-controls="filters-modal"
            aria-expanded={isMobileFiltersOpen}
            disabled={disabled}
            variant="white"
            label={openLabel}
            iconName="filter"
            buttonClasses="tw-w-full [&>div]:tw-justify-between tw-border tw-border-grey-10 hover:tw-border-black"
            contentClasses="tw-text-base"
            onClick={() =>
              dispatch({ type: ActionType.MOBILE_FILTERS_OPEN, payload: true })
            }
          />
        </div>
      )}

      {showSearchInListing && (
        <div className="tw-container tw-mt-sm tw-block lg:tw-inline-block">
          <form onSubmit={handleFormSubmit}>
            <Search
              clearSearch={clearSearch}
              autoCompleteEndpoint={autoCompleteEndpoint}
              setValue={setValue as any}
              errors={errors}
              label={'Search'}
              name={'freetext'}
              initialValue={initialSearchText ?? ''}
              register={register as any}
              placeholder={autoCompletePlaceholder}
              onAutoCompleteSelect={onAutoCompleteSubmit}
              searchClasses="!tw-border-grey-10 [&_svg]:tw-fill-black !tw-text-base"
            />
          </form>
        </div>
      )}
    </div>
  );
};
export default ListingMobileFilters;
